<template>
  <div class="boss-message-heading">
    <div
      class="boss-message-heading-when"
      data-test="date"
    >
      {{ date | formatDate }}
    </div>
    <div
      class="boss-message-heading-title"
      data-test="status-info"
    >
      選考ステータスを「{{ statusName }}」に変更しました。
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'

export default {
  filters: {
    formatDate (val, defaultLabel = '') {
      return val ? dayjs(val).format('YYYY/MM/DD(ddd) HH:mm') : defaultLabel
    }
  },
  props: {
    date: {
      type: String,
      default: ''
    },
    statusName: {
      type: String,
      default: ''
    }
  }
}
</script>
